<template>
  <div class="team row row--hover box box--default">
    <div class="row__data row__data--small row__data--image team__logo">
      <img v-if="userThumbnail" :src="userThumbnail" alt="" />
      <div v-else class="thumbnail thumbnail--team" :style="color">
        {{ parseInitials(tax.team.name) }}
      </div>
    </div>
    <div class="row__data row__data--large row__data--name">
      {{ tax.team.name }}
    </div>


    <div class="row__data row__data--large row__data--address">
      {{ tax.group_name }}
    </div>
    <div class="row__data row__data--large row__data--address">
      {{ tax.name }}
    </div>
    <div class="row__data row__data--medium row__data--rate">
      {{ rateReadable }}
    </div>

    <div class="row__data row__data--action row__data--small" @click.self="showActionsDropdown = !showActionsDropdown"
      v-if="$checkRolePermission('tax_edit')">
      <RowActionDropdown v-if="showActionsDropdown" @toggleDropdown="showActionsDropdown = $event" :onEdit="editTax"
        :onDelete="deleteTax" />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import RowActionDropdown from "@/components/RowActionDropdown";
import { parseInitials } from "@/helpers/entityParsers";

defineOptions({
  name: "TeamTax"
});

const props = defineProps({
  tax: {
    required: true,
    type: Object,
  },
});

const store = useStore();

// State
const showActionsDropdown = ref(false);

// Computed
const userThumbnail = computed(() =>
  props.tax.team.photo ? props.tax.team.photo.thumbnail : null
);

const color = computed(() =>
  props.tax.team.color
    ? { background: props.tax.team.color }
    : { background: "#7f8fa4" }
);

const rateReadable = computed(() =>
  (props.tax.rate * 100).toFixed(2) + " %"
);

// Methods
const editTax = () => {
  store.commit("setTeamTaxToEdit", props.tax);
  store.commit("setTeamTaxIsEdit", true);
  store.commit("setShowAddTeamTaxModal", true);
};
</script>

<style scoped lang="scss">
.row__data--action {
  max-width: 70px;
}

.team__logo {
  max-width: 70px;
}
</style>